/**
 * Converts a camelCase string into kebab-case.
 */
export const camelToKebab = (str: string) => {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};

/**
 * Builds CSS variables by traversing the theme object. Variable names are built by taken the path to the value, and joining it with '-' characters.
 * @param themeObj The theme object to convert to CSS variables.
 * @param prefix The current prefix.
 * @returns A record, mapping from variable name to value.
 */
export const buildThemeVariables = (themeObj: Object, prefix: string = '') => {
  return Object.entries(themeObj).reduce((acc, [key, value]): any => {
    const kebabKey = camelToKebab(key);
    const varPrefix = prefix === '' ? '' : `${prefix}-`;

    if (typeof value === 'object') {
      return { ...acc, ...buildThemeVariables(value, `${varPrefix}${kebabKey}`) };
    }

    return {
      ...acc,
      [`--${varPrefix}${kebabKey}`]: value,
    };
  }, {});
};
